import type { Vibe } from "@majourneys/shared";

/**
 * Ready-made trips offered on the empty Trips page.
 *
 * Real catalogue slugs only, checked against the live API when written
 * (2026-10-11). The owner picks what goes here: no invented stops, no venue we
 * do not carry. A slug that later leaves the catalogue is simply skipped when
 * the trip is copied, and a ready trip with nothing left is not offered.
 *
 * Names and one-line summaries are translation keys, not copy, so the card
 * reads in the guest's language.
 *
 * Kept in its own file with no React in reach, so the app can read the same
 * list through `@majourneys/discover/trips`: one set of ready trips, not two.
 */
export interface ReadyTrip {
  readonly id: string;
  /** i18n key for the trip's name, also used as the copied trip's name. */
  readonly nameKey: string;
  /** i18n key for the one line under the name. */
  readonly lineKey: string;
  readonly city: string;
  readonly vibes: readonly Vibe[];
  /** One entry per day, each a list of catalogue slugs in visiting order. */
  readonly days: readonly (readonly string[])[];
}

export const READY_TRIPS: readonly ReadyTrip[] = [
  {
    id: "marrakech-3-days",
    nameKey: "trip.ready.marrakech_3_days.name",
    lineKey: "trip.ready.marrakech_3_days.line",
    city: "marrakech",
    vibes: ["culture", "foodie", "chill-spa"],
    days: [
      ["marrakech-city-tour", "le-tanjia", "marajah-spa"],
      ["cooking-class-in-a-riad-in-marrakech", "camel-ride-in-marrakech-palm-grove", "dar-soukkar"],
      ["hot-air-balloon-in-marrakech", "la-table-du-marche-marrakech"],
    ],
  },
  {
    id: "agafay-evening",
    nameKey: "trip.ready.agafay_evening.name",
    lineKey: "trip.ready.agafay_evening.line",
    city: "agafay",
    vibes: ["desert", "romantic"],
    days: [["camel-ride-in-agafay", "dinner-show-at-alkamar-camp-agafay"]],
  },
];
